module.exports = __webpack_public_path__ + "img/icon_pending@3x.bb465e87.png";